import axios from "axios";

const pending = [];
const MAX_ACTIVE = 4;
let active = 0;
let scheduled = false;

const drain = () => {
  scheduled = false;
  while (active < MAX_ACTIVE && pending.length) {
    const next = pending.shift();
    next.start();
  }
};

const schedule = () => {
  // Let the browser finish its previous transport lifecycle before starting a new batch.
  if (!scheduled) { scheduled = true; setTimeout(drain, 0); }
};

// Limit thumbnail traffic without queuing the order data, controls or full-size photo downloads.
export const requestListPhoto = (url, config) => new Promise((resolve, reject) => {
  const { signal } = config;
  if (signal?.aborted) { reject(new axios.CanceledError()); return; }
  const cancel = () => {
    const index = pending.indexOf(item);
    if (index !== -1) pending.splice(index, 1);
    reject(new axios.CanceledError());
  };
  const item = { start: () => {
    if (signal?.aborted) { reject(new axios.CanceledError()); return; }
    active += 1;
    // A disappearing row cancels only its subscriber. Keep this transport slot until
    // its tiny response really finishes; aborting XHR freed slots before network teardown.
    const transport = { ...config };
    delete transport.signal;
    axios.get(url, transport).then(resolve, reject).finally(() => {
      signal?.removeEventListener("abort", cancel);
      active -= 1; schedule();
    });
  } };
  config = { ...config, headers: { ...axios.defaults.headers.common, ...config.headers } };
  signal?.addEventListener("abort", cancel, { once: true });
  pending.push(item); schedule();
});